import { SET_CARD_DATA, RESET_CARD_DATA } from "../actions/card";

const initialState = {
  cardData: undefined
};

export default function chargeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CARD_DATA:
      return { ...state, cardData: action.cardForm };
    case RESET_CARD_DATA:
      return { ...state, cardData: undefined };
    default:
      return state;
  }
}
